<template>
  <el-dialog
    :title="`${category._id ? 'Edit' : 'New'} Category`" :model-value="flagVisible" width="30%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="category" label-position="top" size="small" @submit.prevent>
      <el-form-item>
        <el-input v-model="category.name" placeholder="Name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="category.is_published" style="width: 100%;" placeholder="Status">
          <el-option key="1" label="Active" :value="1"></el-option>
          <el-option key="2" label="Pending" :value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="handleClose">CANCEL</el-button>
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">Save</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['closeModal', 'reloadData'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      category: this.actionItem,
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.category = val
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      if (this.category._id) {
        this.updateCategory()
      } else {
        this.createCategory()
      }
    },
    createCategory: function () {
      this.flagLoading.save = true
      const url = '/api/v1/atk_player/admin/categories'
      const that = this
      const body = { ...this.category }
      this.$service.post(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Create category success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadData')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('createCategory', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    updateCategory: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player/admin/categories/${this.category._id}`
      const that = this
      this.$service.put(url, this.category).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update category success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadData')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateCategory', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
